export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

export function clampedModulo(dividend, divisor) {
  let remainder = dividend % divisor
  if ((divisor > 0 && remainder < 0) || (divisor < 0 && remainder > 0)) {
    remainder += divisor
  }
  return remainder
}

export function roundEx(value, digit = 1) {
  return Math.round(value * digit) / digit
}

export function floorEx(value, digit = 1) {
  return Math.floor(value * digit) / digit
}

export function ceilEx(value, digit = 1) {
  return Math.ceil(value * digit) / digit
}

// 弧度法[ radian ]の値を度数法[ degree ]にして返す
export function radToDeg(rad) {
  // 1. const circumference = 2 * Math.PI → 単位円の1周の角度 === 2π[rad]
  // 2. const radRatio =  ( rad / circumference)
  // 3. const deg = radRatio * 360
  return (rad / Math.PI) * 180
}

// 度数法[ degree ]の値を弧度法[ radian ]にして返す
export function degToRad(deg) {
  // 1. circumference = 2 * Math.PI
  // 2. const degRatio = deg / 360
  // 3. const rad = degRatio * circumference
  return (deg * Math.PI) / 180
}

// 円上の指定の角度のx座標を返す
export function getCirclePointX(rad, scale = 1) {
  return Math.cos(rad) * scale
}

// 円上の指定の角度のy座標を返す
export function getCirclePointY(rad, scale = 1) {
  return Math.sin(rad) * scale
}

// 三平方の定理を利用して半径の長さ（直角三角形の斜辺の長さ）を返す
export function getHypotenuseLength(x, y) {
  const square = Math.pow(x, 2) + Math.pow(y, 2)
  return Math.sqrt(square)
}

//　三角関数を利用して、カメラとviewportの距離からViewportにフィットする視野角を求める
export function calcViewportFov(height, distance) {
  return 2 * Math.atan(height / distance) * (180 / Math.PI)
}

//　三角関数を利用して、視野角からViewportにフィットする距離を求める
export function calcViewportDistance(height, fov) {
  return height * .5 / Math.tan(degToRad(fov * 0.5))
}

// 線形補完
export function lerp(start, end, multiplier) {
  return (1 - multiplier) * start + multiplier * end
}